import { createFileRoute } from '@tanstack/react-router';
import { AdminRfqPage } from '../../features/rfq';

export const Route = createFileRoute('/admin/operations/rfq')({ component: AdminRfqPage });
